import React from 'react';
import './Legal.css';

export default function CGV() {
  return (
    <div className="legal-page">
      <h1>Conditions Générales de Vente (CGV)</h1>
      <p><strong>Dernière mise à jour : Décembre 2025</strong></p>

      <p>
        Les présentes Conditions Générales de Vente (CGV) définissent les règles applicables
        aux commandes passées sur le site Aaz Store. Toute commande implique l’acceptation
        totale des présentes CGV.
      </p>

      <h2>1. Produits</h2>
      <p>
        Aaz Store propose la vente de vêtements, chaussures et accessoires pour hommes.
        Les photos et descriptions sont présentées à titre indicatif.
        De légères différences de couleur ou de finition peuvent exister.
      </p>

      <h2>2. Prix</h2>
      <ul>
        <li>Les prix sont indiqués en <strong>Franc CFA (FCFA)</strong></li>
        <li>Les prix peuvent être modifiés à tout moment</li>
        <li>Le prix appliqué est celui affiché au moment de la commande</li>
        <li>Les frais de livraison sont indiqués avant validation</li>
      </ul>

      <h2>3. Commande</h2>
      <p>
        Le client doit fournir des informations exactes (nom, contact, adresse).
        Aaz Store se réserve le droit d’annuler toute commande en cas de stock indisponible
        ou d’informations incorrectes.
      </p>

      <h2>4. Paiement</h2>
      <p><strong>4.1 Commandes à Niamey</strong></p>
      <ul>
        <li>Paiement à la livraison disponible</li>
        <li>Paiement possible par <strong>Nita</strong> ou <strong>Amana</strong></li>
        <li>En cas de paiement Nita ou Amana, le paiement doit être effectué <strong>avant le traitement de la commande</strong></li>
      </ul>

      <p><strong>4.2 Commandes hors de Niamey</strong></p>
      <ul>
        <li>Paiement uniquement par <strong>Nita</strong> ou <strong>Amana</strong></li>
        <li>Le paiement doit être effectué <strong>avant le traitement et l’expédition</strong></li>
        <li>Aucune livraison hors Niamey ne sera effectuée sans paiement confirmé</li>
      </ul>

      <p><strong>4.3 Règle générale</strong></p>
      <ul>
        <li>Tous les paiements par Nita ou Amana doivent être effectués <strong>avant validation de la commande</strong></li>
        <li>Aaz Store se réserve le droit d’annuler toute commande sans paiement confirmé</li>
      </ul>

      <h2>5. Livraison</h2>
      <ul>
        <li>Livraison au Niger uniquement</li>
        <li>Délai moyen : <strong>1 à 2 jours ouvrés</strong></li>
        <li>Les délais peuvent varier selon la destination</li>
        <li>Le client doit vérifier l’état du colis à la réception</li>
      </ul>

      <h2>6. Retours et Échanges</h2>
      <p>
        Le client dispose de <strong>3 jours</strong> après réception pour signaler
        un problème (article défectueux ou erreur).
      </p>
      <ul>
        <li>Les articles doivent être non portés et en bon état</li>
        <li>Les erreurs imputables à Aaz Store sont prises en charge</li>
        <li>Les changements de taille ou d’avis sont à la charge du client</li>
        <li>Les articles portés ou personnalisés ne sont ni repris ni échangés</li>
      </ul>

      <h2>7. Responsabilité</h2>
      <p>
        Aaz Store ne peut être tenu responsable des retards indépendants de sa volonté.
        La responsabilité est limitée au montant de la commande.
      </p>

      <h2>8. Données personnelles</h2>
      <p>
        Les données collectées servent uniquement au traitement des commandes
        et à la communication avec le client.
      </p>

      <h2>9. Droit applicable</h2>
      <p>
        Les présentes CGV sont régies par le <strong>droit en vigueur au Niger</strong>.
        Une solution amiable sera privilégiée en cas de litige.
      </p>

      <h2>10. Contact</h2>
      <p>
        <strong>Email :</strong> aazstore.niam@gmail.com
      </p>
    </div>
  );
}
